import type { ContainerBlockConfig, Direction } from '@lighthouse/core'
import { FLEX_ALIGN } from '@lighthouse/core'
import { nanoid } from '@lighthouse/tools'

/**
 * 生成容器block的配置
 *
 * @returns {ContainerBlockConfig}
 */
export const generateContainerBlock = (mainBreakPoint: string, direction: Direction): ContainerBlockConfig => {
    return {
        viewList: [
            {
                id: nanoid(),
                name: '面板 01'
            }
        ],
        eventList: [],
        breakPoint: {
            id: mainBreakPoint,
            design: {},
            visibility: {
                visible: 'VISIBLE'
            },
            position: {
                type: 'relative'
            },
            size: {
                width: {
                    size: 'fill'
                },
                height: {
                    size: 'auto'
                },
                overflow: 'visible'
            },
            layout: {
                align: {
                    direction,
                    isDistributedAlignment: false,
                    alignX: FLEX_ALIGN['flex-start'],
                    alignY: FLEX_ALIGN['flex-start']
                },
                gap: {
                    size: 8,
                    unit: 'px'
                },
                padding: { size: [4, 4, 4, 4], unit: 'px' }
            }
        },
        breakPoints: []
    }
}
